import { Injectable } from '@angular/core';
import { jsPDF } from 'jspdf';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class JsPDFFontService {
  constructor(private httpClient: HttpClient) {}
  async AddFonts(doc: jsPDF) {
    const bold = await this.httpClient.get('assets/fonts/HindMadurai-Bold.txt', { responseType: 'text' }).toPromise();
    const light = await this.httpClient.get('assets/fonts/HindMadurai-Light.txt', { responseType: 'text' }).toPromise();
    const medium = await this.httpClient
      .get('assets/fonts/HindMadurai-Medium.txt', { responseType: 'text' })
      .toPromise();
    const regular = await this.httpClient
      .get('assets/fonts/HindMadurai-Regular.txt', { responseType: 'text' })
      .toPromise();
    const semiBold = await this.httpClient
      .get('assets/fonts/HindMadurai-SemiBold.txt', { responseType: 'text' })
      .toPromise();

    doc.addFileToVFS('assets/fonts/HindMadurai-Bold.ttf', bold);
    doc.addFileToVFS('assets/fonts/HindMadurai-Light.ttf', light);
    doc.addFileToVFS('assets/fonts/HindMadurai-Medium.ttf', medium);
    doc.addFileToVFS('assets/fonts/HindMadurai-Regular.ttf', regular);
    doc.addFileToVFS('assets/fonts/HindMadurai-SemiBold.ttf', semiBold);
    doc.addFont('assets/fonts/HindMadurai-Bold.ttf', 'HindMadurai-Bold', 'normal');
    doc.addFont('assets/fonts/HindMadurai-Light.ttf', 'HindMadurai-Light', 'normal');
    doc.addFont('assets/fonts/HindMadurai-Medium.ttf', 'HindMadurai-Medium', 'normal');
    doc.addFont('assets/fonts/HindMadurai-Regular.ttf', 'HindMadurai-Regular', 'normal');
    doc.addFont('assets/fonts/HindMadurai-SemiBold.ttf', 'HindMadurai-SemiBold', 'normal');
    doc.setFont('HindMadurai-Regular');
  }
}
